import { Box, Button, Center, HStack, Stack, Text, Link as ChakraLink } from '@chakra-ui/react'
import { Select } from 'chakra-react-select'
import React, { useContext, useState } from 'react'
import { ScoresContext } from '../routes/ScoreListing'
import { SelectOption } from '../types'

function ScoreListingHeader() {
  const [selectedStatuses, setSelectedStatuses] = useState<SelectOption[]>([])

  // Use a two-step type assertion to avoid the type mismatch error
  const context = useContext(ScoresContext)

  // Make sure context is not undefined before using it
  if (!context) {
    return <div>Loading...</div>
  }

  const {
    scores,
    pages,
    changeSelectedStatuses,
    changeSelectedPages,
    applyFilters,
    statusOptions,
    filteredScores,
    approvedScores,
    pushedScores,
  } = context

  const excludeApprovedOrPushed = () => {
    const excludedStatuses = statusOptions.filter(
      (option) => !['AUTO_APPROVED', 'MANUALLY_APPROVED', 'PUSHED'].includes(option.value)
    )
    changeSelectedStatuses(excludedStatuses, setSelectedStatuses)
  }

  // Create page options from the pages array, converting numbers to strings if needed
  const pageOptions: SelectOption[] = pages.map((x) => ({
    label: String(x),
    value: String(x),
  }))

  return (
    <>
      <Stack spacing="20px">
        <Center>
          <HStack spacing="24px">
            <Text>Page: </Text>
            <Box w="250px">
              <Select<SelectOption, true>
                useBasicStyles
                defaultValue={[]}
                isMulti
                name="pagesFilter"
                options={pageOptions}
                onChange={(selected) => changeSelectedPages(selected ? [...selected] : [])}
              />
            </Box>
            <Text>Status:</Text>
            <Box w="600px">
              <Select<SelectOption, true>
                useBasicStyles
                defaultValue={[]}
                isMulti
                name="statusFilter"
                options={statusOptions}
                onChange={(selected) =>
                  changeSelectedStatuses(selected ? [...selected] : [], setSelectedStatuses)
                }
                value={selectedStatuses}
              />
              <ChakraLink color="teal.500" fontSize={12} href="#" onClick={excludeApprovedOrPushed}>
                Exclude approved or pushed
              </ChakraLink>
            </Box>

            <Button variant="solid" colorScheme="red" onClick={applyFilters}>
              Apply
            </Button>
          </HStack>
        </Center>

        <Center>
          <HStack spacing="24px" align="justify">
            <Text>Total scores: {scores.length}</Text>
            <Text>Total approved: {approvedScores.length}</Text>
            <Text>Total pushed: {pushedScores.length}</Text>
            <Text>Others: {scores.length - pushedScores.length - approvedScores.length}</Text>
            <Text>Currently showed: {filteredScores.length}</Text>
          </HStack>
        </Center>
      </Stack>
    </>
  )
}

export default ScoreListingHeader
